<div class="cart_section">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-10 offset-lg-1">
                <div class="cart_container">
                    <div class="cart_title">Shopping Cart<small> ({{cartLength}} item in your cart) </small></div>
                    <div class="cart_items" *ngIf="cartLength">
                        <ul class="cart_list px-0">
                            <li class="cart_item clearfix" *ngFor="let cart of cartProduct">
                                <div class="cart_item_image"><img src="{{cart.image}}" class="img-fluid" alt=""></div>
                                <div class="cart_item_info d-flex flex-md-row flex-column justify-content-between">
                                    <div class="cart_item_name cart_info_col">
                                        <div class="cart_item_title">Name</div>
                                        <div class="cart_item_text">{{cart.title}}</div>
                                    </div>
                                    <div class="cart_item_quantity cart_info_col">
                                        <div class="cart_item_title">Rating</div>
                                        <div class="cart_item_text">{{cart.rating.rate}}</div>
                                    </div>
                                    <div class="cart_item_quantity cart_info_col">
                                        <div class="cart_item_title">Quantity</div>
                                        <div class="cart_item_text">{{cart.count}}</div>
                                    </div>
                                    <div class="cart_item_price cart_info_col">
                                        <div class="cart_item_title">Price</div>
                                        <div class="cart_item_text">{{cart.price}}</div>
                                    </div>
                                    <div class="cart_item_total cart_info_col">
                                        <div class="cart_item_title">Total</div>
                                        <div class="cart_item_text">{{checkPrice(cart)}}</div>
                                    </div>
                                    <div class="cart_item_total cart_info_col">
                                        <div class="cart_item_title pt-3 fs-5 pointer" mat-button (click)="removeProduct(cart)"><i class="fa fa-times" aria-hidden="true"></i>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="order_total" *ngIf="cartLength">
                        <div class="order_total_content text-md-right">
                            <div class="order_total_title">Order Total:</div>
                            <div class="order_total_amount">₹ {{totalAmount}}</div>
                        </div>
                    </div>
                    <div class="cart_buttons" *ngIf="cartLength"> 
                        <button type="button" class="button cart_button_clear" [routerLink]="['/products']">Continue Shopping</button>
                        <button type="button" class="button cart_button_checkout" (click)="clearCart()">Clear Cart</button> 
                    </div>
                    <div class="text-center" *ngIf="!cartLength">
                        <p>No Items in your Cart</p>
                        <button class="button border-0" routerLink="/products">Shop Products</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>